/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    username
    email
    firstName
    lastName
    displayName
    profilePictureUrl
    role
    profileCompleted
    playerConstructs {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getPlayerConstruct = /* GraphQL */ `query GetPlayerConstruct($id: ID!) {
  getPlayerConstruct(id: $id) {
    id
    name
    normalizedName
    totalEvents
    totalPoints
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    leagueStats {
      nextToken
      __typename
    }
    eventResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPlayerConstructQueryVariables,
  APITypes.GetPlayerConstructQuery
>;
export const listPlayerConstructs = /* GraphQL */ `query ListPlayerConstructs(
  $filter: ModelPlayerConstructFilterInput
  $limit: Int
  $nextToken: String
) {
  listPlayerConstructs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPlayerConstructsQueryVariables,
  APITypes.ListPlayerConstructsQuery
>;
export const getLeaguePlayerStats = /* GraphQL */ `query GetLeaguePlayerStats($id: ID!) {
  getLeaguePlayerStats(id: $id) {
    id
    leagueId
    league {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    totalPoints
    totalEvents
    totalWins
    totalLosses
    totalDraws
    bestRank
    averageRank
    averageFinishPercentile
    currentRank
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLeaguePlayerStatsQueryVariables,
  APITypes.GetLeaguePlayerStatsQuery
>;
export const listLeaguePlayerStats = /* GraphQL */ `query ListLeaguePlayerStats(
  $filter: ModelLeaguePlayerStatsFilterInput
  $limit: Int
  $nextToken: String
) {
  listLeaguePlayerStats(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      leagueId
      playerConstructId
      totalPoints
      totalEvents
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      averageFinishPercentile
      currentRank
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLeaguePlayerStatsQueryVariables,
  APITypes.ListLeaguePlayerStatsQuery
>;
export const getLeaguePointAdjustment = /* GraphQL */ `query GetLeaguePointAdjustment($id: ID!) {
  getLeaguePointAdjustment(id: $id) {
    id
    leagueId
    userId
    playerConstructId
    playerName
    points
    reason
    createdBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLeaguePointAdjustmentQueryVariables,
  APITypes.GetLeaguePointAdjustmentQuery
>;
export const listLeaguePointAdjustments = /* GraphQL */ `query ListLeaguePointAdjustments(
  $filter: ModelLeaguePointAdjustmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listLeaguePointAdjustments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      leagueId
      userId
      playerConstructId
      playerName
      points
      reason
      createdBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLeaguePointAdjustmentsQueryVariables,
  APITypes.ListLeaguePointAdjustmentsQuery
>;
export const getEventPlayerResult = /* GraphQL */ `query GetEventPlayerResult($id: ID!) {
  getEventPlayerResult(id: $id) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    points
    omw
    gw
    ogw
    wins
    losses
    draws
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventPlayerResultQueryVariables,
  APITypes.GetEventPlayerResultQuery
>;
export const listEventPlayerResults = /* GraphQL */ `query ListEventPlayerResults(
  $filter: ModelEventPlayerResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listEventPlayerResults(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      eventId
      playerConstructId
      rank
      points
      omw
      gw
      ogw
      wins
      losses
      draws
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventPlayerResultsQueryVariables,
  APITypes.ListEventPlayerResultsQuery
>;
export const getLeague = /* GraphQL */ `query GetLeague($id: ID!) {
  getLeague(id: $id) {
    id
    name
    description
    game
    format
    participationPoints
    winPoints
    drawPoints
    lossPoints
    top8FirstPoints
    top8SecondPoints
    top8ThirdFourthPoints
    top8FifthEighthPoints
    commanderFirstPoints
    commanderSecondPoints
    commanderThirdPoints
    commanderFourthPoints
    premiumMultiplier
    startDate
    endDate
    isActive
    maxParticipants
    playerStats {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLeagueQueryVariables, APITypes.GetLeagueQuery>;
export const listLeagues = /* GraphQL */ `query ListLeagues(
  $filter: ModelLeagueFilterInput
  $limit: Int
  $nextToken: String
) {
  listLeagues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      game
      format
      participationPoints
      winPoints
      drawPoints
      lossPoints
      top8FirstPoints
      top8SecondPoints
      top8ThirdFourthPoints
      top8FifthEighthPoints
      commanderFirstPoints
      commanderSecondPoints
      commanderThirdPoints
      commanderFourthPoints
      premiumMultiplier
      startDate
      endDate
      isActive
      maxParticipants
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLeaguesQueryVariables,
  APITypes.ListLeaguesQuery
>;
export const getEvent = /* GraphQL */ `query GetEvent($id: ID!) {
  getEvent(id: $id) {
    id
    name
    description
    leagueId
    date
    location
    format
    maxRounds
    fieldSize
    isCompleted
    isPremium
    hasTopCut
    playerResults {
      nextToken
      __typename
    }
    topCutResults {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const getEventParticipant = /* GraphQL */ `query GetEventParticipant($id: ID!) {
  getEventParticipant(id: $id) {
    id
    eventId
    userId
    playerConstructId
    commanderCategory
    registrationDate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventParticipantQueryVariables,
  APITypes.GetEventParticipantQuery
>;
export const listEventParticipants = /* GraphQL */ `query ListEventParticipants(
  $filter: ModelEventParticipantFilterInput
  $limit: Int
  $nextToken: String
) {
  listEventParticipants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eventId
      userId
      playerConstructId
      commanderCategory
      registrationDate
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventParticipantsQueryVariables,
  APITypes.ListEventParticipantsQuery
>;
export const getEventStanding = /* GraphQL */ `query GetEventStanding($id: ID!) {
  getEventStanding(id: $id) {
    id
    eventId
    userId
    rank
    points
    omw
    gw
    ogw
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventStandingQueryVariables,
  APITypes.GetEventStandingQuery
>;
export const listEventStandings = /* GraphQL */ `query ListEventStandings(
  $filter: ModelEventStandingFilterInput
  $limit: Int
  $nextToken: String
) {
  listEventStandings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eventId
      userId
      rank
      points
      omw
      gw
      ogw
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventStandingsQueryVariables,
  APITypes.ListEventStandingsQuery
>;
export const getMatch = /* GraphQL */ `query GetMatch($id: ID!) {
  getMatch(id: $id) {
    id
    eventId
    player1Id
    player2Id
    round
    player1Result
    player2Result
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMatchQueryVariables, APITypes.GetMatchQuery>;
export const listMatches = /* GraphQL */ `query ListMatches(
  $filter: ModelMatchFilterInput
  $limit: Int
  $nextToken: String
) {
  listMatches(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eventId
      player1Id
      player2Id
      round
      player1Result
      player2Result
      completedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMatchesQueryVariables,
  APITypes.ListMatchesQuery
>;
export const getCommanderRound = /* GraphQL */ `query GetCommanderRound($id: ID!) {
  getCommanderRound(id: $id) {
    id
    eventId
    roundNumber
    status
    publishedAt
    completedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommanderRoundQueryVariables,
  APITypes.GetCommanderRoundQuery
>;
export const listCommanderRounds = /* GraphQL */ `query ListCommanderRounds(
  $filter: ModelCommanderRoundFilterInput
  $limit: Int
  $nextToken: String
) {
  listCommanderRounds(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eventId
      roundNumber
      status
      publishedAt
      completedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommanderRoundsQueryVariables,
  APITypes.ListCommanderRoundsQuery
>;
export const getCommanderPod = /* GraphQL */ `query GetCommanderPod($id: ID!) {
  getCommanderPod(id: $id) {
    id
    eventId
    roundId
    roundNumber
    podNumber
    category
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommanderPodQueryVariables,
  APITypes.GetCommanderPodQuery
>;
export const listCommanderPods = /* GraphQL */ `query ListCommanderPods(
  $filter: ModelCommanderPodFilterInput
  $limit: Int
  $nextToken: String
) {
  listCommanderPods(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      eventId
      roundId
      roundNumber
      podNumber
      category
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommanderPodsQueryVariables,
  APITypes.ListCommanderPodsQuery
>;
export const getCommanderPodPlayer = /* GraphQL */ `query GetCommanderPodPlayer($id: ID!) {
  getCommanderPodPlayer(id: $id) {
    id
    eventId
    roundId
    podId
    roundNumber
    userId
    playerConstructId
    registeredCategory
    placement
    points
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCommanderPodPlayerQueryVariables,
  APITypes.GetCommanderPodPlayerQuery
>;
export const listCommanderPodPlayers = /* GraphQL */ `query ListCommanderPodPlayers(
  $filter: ModelCommanderPodPlayerFilterInput
  $limit: Int
  $nextToken: String
) {
  listCommanderPodPlayers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      eventId
      roundId
      podId
      roundNumber
      userId
      playerConstructId
      registeredCategory
      placement
      points
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCommanderPodPlayersQueryVariables,
  APITypes.ListCommanderPodPlayersQuery
>;
export const getEventTopCutResult = /* GraphQL */ `query GetEventTopCutResult($id: ID!) {
  getEventTopCutResult(id: $id) {
    id
    eventId
    event {
      id
      name
      description
      leagueId
      date
      location
      format
      maxRounds
      fieldSize
      isCompleted
      isPremium
      hasTopCut
      createdAt
      updatedAt
      __typename
    }
    userId
    user {
      id
      username
      email
      firstName
      lastName
      displayName
      profilePictureUrl
      role
      profileCompleted
      createdAt
      updatedAt
      __typename
    }
    playerConstructId
    playerConstruct {
      id
      name
      normalizedName
      totalEvents
      totalPoints
      totalWins
      totalLosses
      totalDraws
      bestRank
      averageRank
      userId
      createdAt
      updatedAt
      __typename
    }
    rank
    bonusPoints
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEventTopCutResultQueryVariables,
  APITypes.GetEventTopCutResultQuery
>;
export const listEventTopCutResults = /* GraphQL */ `query ListEventTopCutResults(
  $filter: ModelEventTopCutResultFilterInput
  $limit: Int
  $nextToken: String
) {
  listEventTopCutResults(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      eventId
      userId
      playerConstructId
      rank
      bonusPoints
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventTopCutResultsQueryVariables,
  APITypes.ListEventTopCutResultsQuery
>;
